export default __webpack_public_path__ + "images/chat-bot-icon.svg";